import React, {useState, useEffect} from 'react';
import { handleCheckBoxOnChange } from '../../customActions';
import { connect } from "react-redux"; 
import CheckBoxAutosuggest from './CheckBoxAutosuggest';


function CheckboxAutosuggestContainer(props) {

    const {item, handleCheckBoxOnChange, parentIndex } = props;
    const { 
        s_dnm,
        userInput,
        s_type_options
    } = item; 

    const [suggestions, setSuggestions] = useState([]);

    useEffect(() => {

        if(userInput.value && userInput.value.length){
            setSuggestions(userInput.value);
        }else{
            const options = s_type_options.map((s_item, s_index) => {
                return {
                    key: s_index,
                    label: s_item,
                    checked: false
                }
            },[]);
    
            setSuggestions(options);
        }
    }, [])

    return <CheckBoxAutosuggest  
                label={s_dnm} 
                suggestions={suggestions}
                as="dropdown"
                onChange={(selectedItem, data) => {
                    handleCheckBoxOnChange({data, parentIndex, item});
                }}
            />
}

const mapStateToProps = (state, props) => ({
    ...props,
    item: state.productSpecification.editablePuvSpecAttributes[props.parentIndex]
})

const mapDispatchToProps = (dispatch) => ({
    handleCheckBoxOnChange: (payload) => handleCheckBoxOnChange(payload, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CheckboxAutosuggestContainer)